import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router, Event, NavigationEnd, ActivatedRoute} from '@angular/router';
import { ApiService } from './services/api.service';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { ConfigService } from './services/config.service';
import { Title } from '@angular/platform-browser';
import { FeatureFlagService } from './services/feature-flag.service';
import { filter } from 'rxjs/operators';
import { LogglyService } from './services/loggly.service';
import { ThirdPartyService } from './third-party/third-party.service';
import { LayoutService } from './layout/layout.service';
import { SubscriptionsService } from './services/subscriptions.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = '';
  lastUSerActiveCheckTime = 0;
  pol: any;
  subscription= new Subscription;
  private keyName = 'thirdpartyuserkey';
  private keyValue: string | null = null;

  private appkeyName = 'thirdpartyappurl';
  private appkeyValue: string | null = null;


  constructor(private router: Router,
    private apiService: ApiService,
    private titleService: Title,
    public configService: ConfigService,
    private activatedRoute: ActivatedRoute,
    private featureFlagService: FeatureFlagService,
    private logglyService: LogglyService,
    private thirdPartyService: ThirdPartyService,
    private layoutService: LayoutService,
    private subscriptionsService: SubscriptionsService,
  ) {
    this.configService.getAppConfig();
    this.configService.updateAdminType();
    // IOS CHECK
    if(environment.iosReviewInprogress && window.location.href.split('?')[1]) {
      this.apiService.urlParams = '?' + window.location.href.split('?')[1];
      this.apiService.isIos = false;
      const params = window.location.href.split('?')[1].split('&');
      if(params && params.length > 0 && params[0].split('=')[1] === 'ios') {
        this.apiService.isIos = true;
      } 
    }
  }

  ngOnDestroy(): void {
   
  }

  ngOnInit(): void {
    this.router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      ).subscribe(() => {
      this.featureFlagService.updateFeatureFlags();
      this.carryQueryParams();
    });
    
    this.setPageTitle();
    let user = JSON.parse(localStorage.getItem('admin_Details') ?? "null");
    this.configService.sellerDetails = user;
    
    const thirdPartyUserKey = this.thirdPartyService.getThirdPartyUserKeyFromUrl();
    if(thirdPartyUserKey){
      this.layoutService.setUserType('servicenear');
    }
    this.logglyService.log('AppComponent - Third party user key: ' + thirdPartyUserKey);
  }

  ngAfterViewInit() {
    const loader = document.getElementById('global-loader');
    if (loader) {
      loader.style.opacity = '0';
      setTimeout(() => loader.remove(), 300);
    }
  }

  @HostListener('window:load', ['$event'])
  onload(event: Event) { 
    this.configService.getSubscriptionDetails();
    this.configService.getSettingsBySellerId();
    this.subscriptionsService.setSubscriptionFeaturesIfAuthenticated();
    const subDomain = this.getSubDomainFromUrl();
    if (subDomain && environment.appName === "Bazaarnear") {
      this.configService.getSellerDetailsAndUpdateBasicDetails(subDomain);
    }
  }

  private getSubDomainFromUrl() { 
    const hostname = window.location.hostname;
    const hostnameWithoutProtocol = hostname.replace(/(^\w+:|^)\/\//, '');
    const parts = hostnameWithoutProtocol.split('.');
    if (parts.length > 2) {  
      return parts[0];
    }
    return null;
  }
  
  private carryQueryParams() {
    const currentUrlTree = this.router.parseUrl(this.router.url);
    const queryParams = { ...currentUrlTree.queryParams };

    let changed = false;

    // Check if key is in the current URL
    if (queryParams[this.keyName]) {
      this.keyValue = queryParams[this.keyName];
    } else if (this.keyValue) {
      // Re-navigate with the key appended
      queryParams[this.keyName] = this.keyValue;
      changed = true;
    }
    if (queryParams[this.appkeyName]) {
      this.appkeyValue = queryParams[this.appkeyName];
    } else if (this.appkeyValue) {
      // Re-navigate with the key appended
      queryParams[this.appkeyName] = this.appkeyValue;
      changed = true;
    }

    if (!changed) {
      return; //Do nothing if params already there → avoids infinite loop
    }
    
    const newUrlTree = this.router.createUrlTree([], {
        relativeTo: this.activatedRoute,
        queryParams,
        queryParamsHandling: 'merge',
      });

      // Replace the current URL silently without triggering a reload
      this.router.navigateByUrl(newUrlTree, { replaceUrl: true });
  }

  private checkIsUserActive() {
    if (localStorage.getItem('admin_Details')) {
      this.subscription.add(this.apiService.checkIsUSerActive().subscribe((res: any) => {
        this.lastUSerActiveCheckTime = Number(moment.unix(Date.now())) / 1000;
        if (res && res.ResponseData && res.ResponseData !== "valid") {
          localStorage.clear();
          this.router.navigate(['/public/login']);
        }
      }));
    }
  }

  private setPageTitle() {
    this.titleService.setTitle(environment.appName);
  }
}
